export default __webpack_public_path__ + "static/media/coinbase.0472eadc.svg";